export default __webpack_public_path__ + "static/media/Audio-Number-8.eb71ae84.mp3";